import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import { app } from '../firebase.js';
import { 
  getFirestore, 
  collection, 
  addDoc, 
  getDocs, 
  query, 
  orderBy, 
  Timestamp, 
  updateDoc, 
  deleteDoc, 
  doc 
} from 'firebase/firestore';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function PriceComp() {
  const db = getFirestore(app);
  const [show, setShow] = useState(false);
  const [route, setRoute] = useState('');
  const [location, setLocation] = useState('');
  const [price, setPrice] = useState('');
  const [prices, setPrices] = useState([]);
  const [search, setSearch] = useState('');
  const [filtered, setFiltered] = useState([]);
  const [editingId, setEditingId] = useState(null);

  const handleClose = () => {
    setShow(false);
    setEditingId(null);
    setRoute('');
    setLocation('');
    setPrice('');
  };
  const handleShow = () => setShow(true);

  // Save or update price
  const handleSave = async () => {
    if (!route || !location || !price) return;

    try {
      if (editingId) {
        // Update
        const ref = doc(db, 'prices', editingId);
        await updateDoc(ref, {
          route,
          location,
          price: Number(price),
        });
      } else {
        // Add new
        await addDoc(collection(db, 'prices'), {
          route,
          location,
          price: Number(price),
          createdAt: Timestamp.now()
        });
      }
      handleClose();
      fetchPrices();
    } catch (err) {
      console.error("Error saving price: ", err);
    }
  };

  // Edit price
  const handleEdit = (item) => {
    setEditingId(item.id);
    setRoute(item.route);
    setLocation(item.location);
    setPrice(item.price);
    setShow(true);
  };

  // Delete price
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this price?")) {
      try {
        await deleteDoc(doc(db, 'prices', id));
        fetchPrices();
      } catch (err) {
        console.error("Error deleting price: ", err);
      }
    }
  };

  // Fetch prices
  const fetchPrices = async () => {
    const q = query(collection(db, 'prices'), orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);
    const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setPrices(list);
    setFiltered(list);
  };

  // Search filter
  useEffect(() => {
    if (!search) {
      setFiltered(prices);
      return;
    }
    const lower = search.toLowerCase();
    const results = prices.filter(
      (item) =>
        item.route.toLowerCase().includes(lower) ||
        item.location.toLowerCase().includes(lower)
    );
    setFiltered(results);
  }, [search, prices]);

  useEffect(() => {
    fetchPrices();
  }, []);

  return (
    <div className="dataComp">
      <div className="dataCompTop d-flex justify-content-between align-items-center mb-3">
        <h5>Price List</h5>
        <div className="searchContainer d-flex gap-2">
          <div className="d-flex align-items-center">
            <FontAwesomeIcon icon={faSearch} className="searchIcon me-2" />
            <input 
              type="text" 
              placeholder="Type to search by route or location" 
              value={search} 
              onChange={(e) => setSearch(e.target.value)} 
              className="form-control"
            />
          </div>
          <Button variant="primary" onClick={handleShow}>
            Add a Location
          </Button>
        </div>
      </div>

      {/* Table */}
      <Table striped bordered hover size="sm">
        <thead>
          <tr>
            <th>Route</th>
            <th>Location</th>
            <th>Price</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((item) => (
            <tr key={item.id}>
              <td>{item.route}</td>
              <td>{item.location}</td>
              <td>{item.price}</td>
              <td>
                <Button 
                  variant="warning" 
                  size="sm" 
                  className="me-2"
                  onClick={() => handleEdit(item)}
                >
                  <FontAwesomeIcon icon={faEdit} /> Edit
                </Button>
                <Button 
                  variant="danger" 
                  size="sm" 
                  onClick={() => handleDelete(item.id)}
                >
                  <FontAwesomeIcon icon={faTrash} /> Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{editingId ? 'Edit Price' : 'Add a Location Price'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Route</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="e.g. Lang'ata, Waiyaki Way" 
                value={route} 
                onChange={(e) => setRoute(e.target.value)} 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Location</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="e.g. Nairobi West" 
                value={location} 
                onChange={(e) => setLocation(e.target.value)} 
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Price</Form.Label>
              <Form.Control 
                type="number" 
                placeholder="e.g. 300" 
                value={price} 
                onChange={(e) => setPrice(e.target.value)} 
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Cancel</Button>
          <Button variant="primary" onClick={handleSave}>
            {editingId ? 'Update' : 'Save'}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default PriceComp;